/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Browser_Extensions_Submit_Title6Inputs */

const en_svc_browser_extensions_submit_title6 = /** @type {(inputs: Svc_Browser_Extensions_Submit_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store submission`)
};

const ar_svc_browser_extensions_submit_title6 = /** @type {(inputs: Svc_Browser_Extensions_Submit_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تقديم المتجر`)
};

const bn_svc_browser_extensions_submit_title6 = /** @type {(inputs: Svc_Browser_Extensions_Submit_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্টোর সাবমিশন`)
};

const de_svc_browser_extensions_submit_title6 = /** @type {(inputs: Svc_Browser_Extensions_Submit_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store-Übermittlung`)
};

const es_svc_browser_extensions_submit_title6 = /** @type {(inputs: Svc_Browser_Extensions_Submit_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envío de tienda`)
};

const fr_svc_browser_extensions_submit_title6 = /** @type {(inputs: Svc_Browser_Extensions_Submit_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soumission du magasin`)
};

const pt_svc_browser_extensions_submit_title6 = /** @type {(inputs: Svc_Browser_Extensions_Submit_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envio da loja`)
};

const zh_svc_browser_extensions_submit_title6 = /** @type {(inputs: Svc_Browser_Extensions_Submit_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商店提交`)
};

const tr_svc_browser_extensions_submit_title6 = /** @type {(inputs: Svc_Browser_Extensions_Submit_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mağaza gönderimi`)
};

const ru_svc_browser_extensions_submit_title6 = /** @type {(inputs: Svc_Browser_Extensions_Submit_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправка в магазин`)
};

const pl_svc_browser_extensions_submit_title6 = /** @type {(inputs: Svc_Browser_Extensions_Submit_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przesyłanie do sklepu`)
};

/**
* | output |
* | --- |
* | "Store submission" |
*
* @param {Svc_Browser_Extensions_Submit_Title6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_browser_extensions_submit_title6 = /** @type {((inputs?: Svc_Browser_Extensions_Submit_Title6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Browser_Extensions_Submit_Title6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_browser_extensions_submit_title6(inputs)
	if (locale === "bn") return bn_svc_browser_extensions_submit_title6(inputs)
	if (locale === "de") return de_svc_browser_extensions_submit_title6(inputs)
	if (locale === "es") return es_svc_browser_extensions_submit_title6(inputs)
	if (locale === "fr") return fr_svc_browser_extensions_submit_title6(inputs)
	if (locale === "pt") return pt_svc_browser_extensions_submit_title6(inputs)
	if (locale === "zh") return zh_svc_browser_extensions_submit_title6(inputs)
	if (locale === "tr") return tr_svc_browser_extensions_submit_title6(inputs)
	if (locale === "ru") return ru_svc_browser_extensions_submit_title6(inputs)
	if (locale === "pl") return pl_svc_browser_extensions_submit_title6(inputs)
	return en_svc_browser_extensions_submit_title6(inputs)
});
export { svc_browser_extensions_submit_title6 as "svc_browser-extensions_SUBMIT_title" }